import { useState } from 'preact/hooks';

import LoyaltyProgramContextProvider from '@/context/LoyaltyProgramContext';

import { ErrorBoundary } from './ErrorBoundary';
import { FloatingWidgetTrigger } from './FloatingWidgetTrigger';
import { WidgetBody } from './WidgetBody';

export const Widget = () => {
  const [isWidgetOpen, setIsWidgetOpen] = useState(false);

  const closeWidget = () => setIsWidgetOpen(false);
  const toggleWidget = () => setIsWidgetOpen((prev) => !prev);

  return (
    <ErrorBoundary>
      <FloatingWidgetTrigger isWidgetOpen={isWidgetOpen} openWidget={toggleWidget} />
      <LoyaltyProgramContextProvider>
        <WidgetBody isWidgetOpen={isWidgetOpen} closeWidget={closeWidget} />
      </LoyaltyProgramContextProvider>
    </ErrorBoundary>
  );
};
